import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
import type { CtaProps, SecondaryCtaProps } from './cta.types';
import { CtaButton } from './cta-button';
import { CtaLink } from './cta-link';

/** The heading `PageShell` stamps, so a host can mirror the visible title elsewhere. */
const PAGE_TITLE_ID = 'page-shell-title';
type PageShellProps = {
  children: ReactNode;
  title?: string;
  subtitle?: ReactNode;
  header?: ReactNode;
  cta?: CtaProps;
  secondaryCta?: SecondaryCtaProps;
  /** Centered under the actions, or in their place when there are none. */
  caption?: ReactNode;
  isLoading?: boolean;
  headerIcon?: ReactNode;
  headerTitleClassName?: string;
  options?: {
    headerTitleCentered?: boolean;
  };
};
const PageShell = t0 => {
  const $ = _c(19);
  const {
    children,
    title,
    subtitle,
    header,
    cta,
    secondaryCta,
    caption,
    isLoading,
    headerIcon,
    options: t1
  } = t0;
  let t2;
  let t3;
  if ($[0] !== header || $[1] !== headerIcon || $[2] !== subtitle || $[3] !== t1 || $[4] !== title) {
    const {
      headerTitleCentered: t4
    } = t1 === undefined ? {
      headerTitleCentered: false
    } : t1;
    const headerTitleCentered = t4 === undefined ? false : t4;
    t2 = "page-shell flex flex-col gap-6 flex-1";
    t3 = header ?? <header className="page-shell__header fp-custom-appearance fp-page-header flex flex-col gap-2 items-center">{headerIcon && <div className="flex justify-center items-center">{headerIcon}</div>}{title && <h1 id={PAGE_TITLE_ID} className={cx("fp-custom-appearance fp-page-header-title text-heading-3 text-primary", {
        "text-center": headerTitleCentered
      })}>{title}</h1>}{subtitle && <p className="fp-custom-appearance fp-page-header-subtitle text-body-2 text-secondary text-center">{subtitle}</p>}</header>;
    $[0] = header;
    $[1] = headerIcon;
    $[2] = subtitle;
    $[3] = t1;
    $[4] = title;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children) {
    t4 = children && <main className="page-shell__content flex-1">{children}</main>;
    $[7] = children;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== caption || $[10] !== cta || $[11] !== isLoading || $[12] !== secondaryCta) {
    t5 = (cta || secondaryCta || caption) && <div className="page-shell__cta flex flex-col gap-3">{cta && <CtaButton cta={cta} isLoading={isLoading} />}{secondaryCta && (secondaryCta.variant === "link" ? <CtaLink cta={secondaryCta} /> : <CtaButton cta={secondaryCta} variant="secondary" />)}{caption && <p className="page-shell__caption text-body-2 text-tertiary text-center">{caption}</p>}</div>;
    $[9] = caption;
    $[10] = cta;
    $[11] = isLoading;
    $[12] = secondaryCta;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <div className={t2}>{t3}{t4}{t5}</div>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
export type { CtaProps, PageShellProps, SecondaryCtaProps };
export { PAGE_TITLE_ID };
export default PageShell;